export const zh = {
  "AddTranslation":"添加翻译"
};

